<div
  class="mfa-timeout-dialog"
  id="mfa-timeout-dialog"
  data-test-id="mfa-timeout"
>
  <div mat-dialog-title id="mfaTimeoutDialogHeader">
    <h1
      data-test-id="mfa-timeout-heading"
      class="mfa-timeout-title"
      aria-label="Mfa Timeout header"
      tabindex="0"
    >
      <ng-container [ngSwitch]="reason">
        <ng-container *ngSwitchCase="RESEND_EXCEED_LIMIT">
          {{ 'brokerMfa.mfaResendExceedLimitModalHeader' | translate }}
        </ng-container>
        <ng-container *ngSwitchCase="CODE_EXCEED_LIMIT">
          {{ 'brokerMfa.mfaCodeExceedLimitModalHeader' | translate }}
        </ng-container>
        <ng-container *ngSwitchDefault>
          {{ 'brokerMfa.mfaTimeoutModalHeader' | translate }}
        </ng-container>
      </ng-container>
    </h1>
  </div>

  <mat-dialog-content
    aria-labelledby="Mfa Timeout modal"
    class="mfa-timeout-dialog-content"
  >
    <p class="mfa-timeout-message" data-test-id="mfa-timeout-body">
      <ng-container [ngSwitch]="reason">
        <ng-container *ngSwitchCase="RESEND_EXCEED_LIMIT">
          {{ 'brokerMfa.mfaResendExceedLimitModalBody' | translate }}
        </ng-container>
        <ng-container *ngSwitchCase="CODE_EXCEED_LIMIT">
          {{ 'brokerMfa.mfaCodeExceedLimitModalBody' | translate }}
        </ng-container>
        <ng-container *ngSwitchDefault>
          {{ 'brokerMfa.mfaTimeoutModalBody' | translate }}
        </ng-container>
      </ng-container>
    </p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="mfa-timeout-btn-section">
      <button
        type="button"
        mat-raised-button
        cg-mat-btn-type="primary"
        class="ls-button-fill mfa-timeout-btn"
        data-test-id="mfa-timeout-button"
        (click)="continue()"
      >
        <span class="mfa-timeout-btn-label">{{
          'global.continue' | translate
        }}</span>
      </button>
    </div>
  </mat-dialog-actions>
</div>
